// example taken from PrivateRoute implementation:
// https://www.graph.cool/forum/t/react-hoc-to-check-for-authorized-user-protected-routes/478/3
import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, auth, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      auth ? (
        <Component auth={auth} {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/HOC/Auth/PrivateRoute.js